// PatientHistoryPage.js
import React from 'react';

const PatientHistoryPage = () => {
  return (
    <div className="container py-4">
      <h4>className="mb-4">Patient History</h4>
      <p>This page will show the list of past patients and their medical history records.</p>
      {/* You can use a table to show patient name, visit date, treatment, etc. */}
    </div>
  );
};

export default PatientHistoryPage;